/**
 * @file 保存済検索条件を削除する
 */
'use strict'
import Common from '../../Utils/Common'

/**
 * @classname BtnDeleteFilter
 * @classdesc 保存済検索条件を削除する
 */
export default class BtnDeleteFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-delete-filter')
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._controller = controller
		this._id = this._$e.data('filter-id')
		this._searchType = $('#search_type').val()
		this._SavedFiltersModal = bootstrap.Modal.getInstance(document.getElementById('modal-saved-filters'))
		this._completeFilterDeleteModal = document.getElementById('modal-complete-filter-delete')
		this._CompleteFilterDeleteModal = bootstrap.Modal.getInstance(this._completeFilterDeleteModal)
		this._$e.on('click', () => this.onClick())
		this._completeFilterDeleteModal.addEventListener('hidden.bs.modal', () => this.getSavedFilters())
		this._controller.on('deleteFilterComplete', () => this.onDeleteFilterComplete())
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnDeleteFilter
	 */
	onClick() {
		console.log('BtnDeleteFilter.onClick')
		this._SavedFiltersModal.hide()
		this._controller.deletingFilterId = this._id
		this._controller.deleteFilter(this._id)
	}


	/**
	 * 保存済検索条件削除完了時のコールバック
	 *
	 * @memberof BtnDeleteFilter
	 */
	onDeleteFilterComplete() {
		if (this._id !== this._controller.deletingFilterId) return
		console.log('BtnDeleteFilter.onDeleteFilterComplete')
		this._CompleteFilterDeleteModal.show()
	}


	/**
	 * 保存済検索条件リストの取得
	 *
	 * @memberof BtnDeleteFilter
	 */
	getSavedFilters() {
		console.log('BtnDeleteFilter.getSavedFilters')
		this._controller.getSavedFilters(this._searchType)
	}
}
 